
  <mat-card class="start-page-card-narrow">
    <mat-card-header>
      <mat-card-title>Assessment Questionnaire</mat-card-title>
    </mat-card-header>
      <mat-card-content class="m-t-1">
       
          <form #assessmentForm="ngForm" class="start-page-form">
                       
            <!-- Main Form Type Selection -->
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>I would like to</mat-label>
              <mat-select [(ngModel)]="applyOrSponsor" name="applyOrSponsor" (selectionChange)="onApplyOrSponsorChange()">
                <mat-option value="resumeSavedForm">
                  Resume a saved assessment
                </mat-option>
                @if (hasAnyFlag(applyFlags)) {
                  <mat-option value="apply">
                    Apply for a Visa
                  </mat-option>
                }
                @if (hasAnyFlag(sponsorFamilyFlags)) {
                  <mat-option value="sponsorFamily">
                    Sponsor a Family Member
                  </mat-option>
                }
                @if (hasAnyFlag(sponsorEmployeeFlags)) {
                  <mat-option value="sponsorEmployee">
                    Sponsor an Employee
                  </mat-option>
                }
                @if (hasAnyFlag(appealFlags)) {
                  <mat-option value="appeal">
                    Apply to Appeal
                  </mat-option>
                }
                @if (hasAnyFlag(vevoFlags)) {
                  <mat-option value="vevo">
                    Verify Visa Entitlements
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <!-- Apply Form Options -->
            @if (applyOrSponsor === 'apply') {
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label>Select Application Type</mat-label>
                <mat-select [(ngModel)]="selectedForm" name="selectedForm">
                  @if (hasFlag(AssessmentFlags.VisaStudyInAustralia)) {
                    <mat-option [value]="formTypes.study">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaStudyInAustralia]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaWorkInAustralia)) {
                    <mat-option [value]="formTypes.work">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaWorkInAustralia]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaSkilledMigrant)) {
                    <mat-option [value]="formTypes.skilled">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaSkilledMigrant]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaJoinSpouse)) {
                    <mat-option [value]="formTypes.partner">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaJoinSpouse]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaJoinParents)) {
                    <mat-option [value]="formTypes.child">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaJoinParents]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaJoinChild)) {
                    <mat-option [value]="formTypes.parent">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaJoinChild]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaVisitAustralia)) {
                    <mat-option [value]="formTypes.visit">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaVisitAustralia]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaOwnABusiness)) {
                    <mat-option [value]="formTypes.business">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaOwnABusiness]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VisaNotSure)) {
                    <mat-option [value]="formTypes.generic">
                      {{ AssessmentFlagLabels[AssessmentFlags.VisaNotSure]}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            <!-- Sponsor Family Options -->
            @if (applyOrSponsor === 'sponsorFamily') {
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label>Select Family Sponsorship Type</mat-label>
                <mat-select [(ngModel)]="selectedForm" name="selectedFamilyForm">
                  @if (hasFlag(AssessmentFlags.SponsorChild)) {
                    <mat-option [value]="formTypes.child">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorChild]}}
                    </mat-option>
                  }
                  @if (hasFlag( AssessmentFlags.SponsorPartner)) {
                    <mat-option [value]="formTypes.partner">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorPartner]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.SponsorParent)) {
                    <mat-option [value]="formTypes.parent">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorParent]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.SponsorFamilyNotSure)) {
                    <mat-option [value]="formTypes.generic">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorFamilyNotSure]}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            <!-- Sponsor Employee Options -->
            @if (applyOrSponsor === 'sponsorEmployee') {
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label>Select Employee Sponsorship Type</mat-label>
                <mat-select [(ngModel)]="selectedForm" name="selectedEmployeeForm">
                  @if (hasFlag(AssessmentFlags.SponsorEmployeeTempWork)) {
                    <mat-option [value]="formTypes.employerTemp">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorEmployeeTempWork]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.SponsorEmployeePermanentResidence)) {
                    <mat-option [value]="formTypes.employerPerm">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorEmployeePermanentResidence]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.SponsorEmployeeNotSure)) {
                    <mat-option [value]="formTypes.businessEnquiry">
                      {{ AssessmentFlagLabels[AssessmentFlags.SponsorEmployeeNotSure]}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            <!-- Appeal Options -->
            @if (applyOrSponsor === 'appeal') {
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label>Select Appeal Type</mat-label>
                <mat-select [(ngModel)]="selectedForm" name="selectedAppealForm">
                  @if (hasFlag(AssessmentFlags.AppealRefused)) {
                    <mat-option [value]="formTypes.appealRefuse">
                      {{ AssessmentFlagLabels[AssessmentFlags.AppealRefused]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.AppealCancelled)) {
                    <mat-option [value]="formTypes.appealCancel">
                      {{ AssessmentFlagLabels[AssessmentFlags.AppealCancelled]}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            <!-- VEVO Options -->
            @if (applyOrSponsor === 'vevo') {
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label>Select VEVO Check Type</mat-label>
                <mat-select [(ngModel)]="selectedForm" name="selectedVevoForm">
                  @if (hasFlag(AssessmentFlags.VerifyVisaDirectEmployee)) {
                    <mat-option [value]="formTypes.vevoEmployee">
                      {{ AssessmentFlagLabels[AssessmentFlags.VerifyVisaDirectEmployee]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VerifyVisaContractedWorker)) {
                    <mat-option [value]="formTypes.vevoContract">
                      {{ AssessmentFlagLabels[AssessmentFlags.VerifyVisaContractedWorker]}}
                    </mat-option>
                  }
                  @if (hasFlag(AssessmentFlags.VerifyVisaMyself)) {
                    <mat-option [value]="formTypes.vevoMyself">
                      {{ AssessmentFlagLabels[AssessmentFlags.VerifyVisaMyself]}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </form>
    
      </mat-card-content>
<mat-card-content>
  <app-start-page-notices (termsChanged)="onTermsAcceptedChange($event)" [nextClicked]="nextClicked"></app-start-page-notices>
</mat-card-content>
      <mat-card-actions class="start-page-buttons">
        <button 
          mat-flat-button 
          (click)="goToNext()" 
          [disabled]="nextButtonDisabled()">
          Next
        </button>
      </mat-card-actions> 
  </mat-card>
